import { Box, Button, Grid2 } from "@mui/material";
import React, { useState, useEffect } from "react";
import SideBar from "../SideBar/SideBar";
import { useTheme, useMediaQuery } from "@mui/material";
import '../Assistant/Assistant.css';
import Stack from "@mui/material/Stack";
import Typography from '@mui/material/Typography';
import TextField from "@mui/material/TextField";
import { ToastContainer, toast } from 'react-toastify';
import { Link, useNavigate } from "react-router-dom";
import BookmarkAddedIcon from '@mui/icons-material/BookmarkAdded';
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PropTypes from "prop-types";
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
// date
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import SearchIcon from "@mui/icons-material/Search";
import { IconButton } from "@mui/material";
import TablePagination from '@mui/material/TablePagination';
// Table
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import './Billing.css'
import Tick from '../../Images/tick.svg'
import Collapse from "@mui/material/Collapse";
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import PaymentIcon from '@mui/icons-material/Payment';


// BorderLinearProgress
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 5,
  borderRadius: 5,
  background: '#F2DFFF !important',
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[800],
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#2F024E',
    ...theme.applyStyles('dark', {
      backgroundColor: '#308fe8',
    }),
  },
}));

function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{ color: '#fff' }}
        >
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

const rows = [
  createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
  createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
  createData('Eclair', 262, 16.0, 24, 6.0),
  createData('Cupcake', 305, 3.7, 67, 4.3),
  createData('Gingerbread', 356, 16.0, 49, 3.9),
];
function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2F024E',
    color: '#fff',

  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 10,
    border: 'none',
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: 'rgba(226, 186, 253, 0.30)',
    border: 'none',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 'none',
  },
}));

const label = { inputProps: { 'aria-label': 'Switch demo' } };

// tap
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const drawerWidth = 300;
const Billing = () => {
  const notify = () => toast.success('Setup Completed');
  const remove = () => toast.success('Deleted successfully');

  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("sm"));

  const [pop, setPop] = useState(false);
  const handlePopOpen = () => setPop(true);
  const handlePopClose = () => setPop(false);
  // tab
  const [tab, setTab] = useState(0);
  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const navigate = useNavigate();


  // search
  const [searchValue, setSearchValue] = useState("");
  const handleSearch = () => {
    // Add logic to handle search
  };
  // TablePagination-start
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(3);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value)

    setPage(0);
  };
  // TablePagination-end   

  // sameMap
  const [sameMap, setsameMap] = React.useState(false);
  const [expandedMap, setExpandedMap] = React.useState(false);

  const handleExpandClickMap = () => {
    setsameMap(false);
    setExpandedMap(!expandedMap);
  };
  const handleExpandClickSameMap = () => {
    setExpandedMap(false);
    setsameMap(!sameMap);
  };
  // progress
  const [progress, setProgress] = React.useState(10);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 1));
    }, 12000);
    return () => {
      clearInterval(timer);
    };
  }, []);
  return (
    <div className="Billing">
      <Box sx={{ display: isLgUp ? "flex" : "block"}}>
        <SideBar />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: isLgUp ? 5 : 1,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            marginTop: isLgUp ? "0px" : "80px",
          }}
        >
          <Grid2 container spacing={2}>
            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} className="mb-20">
              <div className="PhoneNumber-main">
                <div className="display-2 heading-line">
                  <h3>Billing</h3>
                  <Stack direction="row" spacing={2} sx={{ justifyContent: "center" }}>
                    <div className="bg-clr mt-10">
                      <Button startIcon={<PaymentIcon />}>Change Payment Details</Button>
                    </div>
                  </Stack>
                </div>
              </div>
            </Grid2>
            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} className="mb-20">
              <div className="">
                <div className="tab-common">
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs
                      value={tab}
                      onChange={handleTabChange}
                      aria-label="basic tabs example"
                    >
                      <Tab icon={<RecordVoiceOverIcon />} iconPosition="start" label="My Subscription" {...a11yProps(0)} />
                      <Tab label="View Invoice" {...a11yProps(1)} />
                      {/* <Tab label="Item Three" {...a11yProps(2)} /> */}
                    </Tabs>
                  </Box>
                  <CustomTabPanel value={tab} index={0}>
                    <div className="My-Subscription">
                      <Box>
                        <Grid2 container spacing={4}>
                          <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} className="mb-20">
                            <div className="My-Subscription-Details display-2">
                              <h4>Primary Plan Details</h4>
                              <div className="bg-clr-white mt-10">
                                <Button>Other plans</Button>
                              </div>
                            </div>
                            <div className="My-Subscription-Details2">
                              <Grid2 container spacing={2} className="mb-20 mt-30">
                                <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} className="mb-20">
                                  <h5>Free Plan</h5>
                                </Grid2>
                                <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} sx={{ height: '100px' }}>
                                  <div className="characters-heading"><img src={Tick} /><p> 5 minutes for first time</p></div>
                                  <div className="characters-heading"><img src={Tick} /><p> Up to 10 Human Associates</p></div>
                                </Grid2>
                              </Grid2>
                            </div>

                            <Box sx={{ padding: '10px 20px', background: '#fff', borderRadius: '12px', border: '2px solid #8087D7', marginTop: '20px' }}>
                              <div className="display-2 ">
                                <Typography id="modal-modal-title" variant="h6" component="h6" sx={{fontSize:'18px'}}>
                                  Addon Plan Details
                                </Typography>
                                <div className="bg-clr">
                                  <Button>Buy Addons</Button>
                                </div>
                              </div>
                            </Box>
                          </Grid2>
                          <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} className="mb-20">
                            <div className="My-Subscription-Details display-2">
                              <h4>Usage Details</h4>
                              <div className="bg-clr-white mt-10">
                                <Button onClick={handleExpandClickMap}>More Details</Button>
                              </div>
                            </div>
                            <div className="My-Subscription-Details2">
                              <div className="Minutes1">
                                <Box sx={{ padding: '10px 20px', background: '#fff', borderRadius: '12px', marginTop: '20px', backgroundColor: '#2F024E' }}>
                                  <div className="display-2 ">
                                    <Typography id="modal-modal-title" variant="h6" component="h5" sx={{ color: '#fff' }}>
                                      Minutes
                                    </Typography>
                                    <CircularProgressWithLabel color="inherit" value={progress} />
                                  </div>
                                </Box>
                                <Collapse in={expandedMap} timeout="auto" unmountOnExit>
                                  <div className="My-Subscription-Details-Minutes">
                                    <div className="display-2 mb-10">
                                      <Typography id="modal-modal-title" variant="h6" component="h6" sx={{ color: '#000', fontSize: '14px' }}>
                                        Total Minutes
                                      </Typography>
                                      <Typography id="modal-modal-title" variant="p" component="p" sx={{ color: '#000' }}>
                                        1/5
                                      </Typography>
                                    </div>
                                    <BorderLinearProgress variant="determinate" value={50} />
                                  </div>
                                  <div className="My-Subscription-Details-Minutes">
                                    <div className="display-2 mb-10">
                                      <Typography id="modal-modal-title" variant="h6" component="h6" sx={{ color: '#000', fontSize: '14px' }}>
                                      Primary Minutes
                                      </Typography>
                                      <Typography id="modal-modal-title" variant="p" component="p" sx={{ color: '#000' }}>
                                        1/5
                                      </Typography>
                                    </div>
                                    <BorderLinearProgress variant="determinate" value={35} />
                                  </div>
                                </Collapse>
                              </div>

                              <div className="Minutes2">
                                <Box sx={{ padding: '10px 20px', background: '#fff', borderRadius: '12px', marginTop: '20px', backgroundColor: '#2F024E' }}>
                                  <div className="display-2 ">
                                    <Typography id="modal-modal-title" variant="h6" component="h5" sx={{ color: '#fff' }}>
                                    Assistants
                                    </Typography>
                                    <CircularProgressWithLabel color="inherit" value={progress} />
                                  </div>
                                </Box>
                                <Collapse in={expandedMap} timeout="auto" unmountOnExit>
                                  <div className="My-Subscription-Details-Minutes">
                                    <div className="display-2 mb-10">
                                      <Typography id="modal-modal-title" variant="h6" component="h6" sx={{ color: '#000', fontSize: '14px' }}>
                                        Total Minutes
                                      </Typography>
                                      <Typography id="modal-modal-title" variant="p" component="p" sx={{ color: '#000' }}>
                                        1/5
                                      </Typography>
                                    </div>
                                    <BorderLinearProgress variant="determinate" value={50} />
                                  </div>
                                  <div className="My-Subscription-Details-Minutes">
                                    <div className="display-2 mb-10">
                                      <Typography id="modal-modal-title" variant="h6" component="h6" sx={{ color: '#000', fontSize: '14px' }}>
                                      Primary Minutes
                                      </Typography>
                                      <Typography id="modal-modal-title" variant="p" component="p" sx={{ color: '#000' }}>
                                        1/5
                                      </Typography>
                                    </div>
                                    <BorderLinearProgress variant="determinate" value={35} />
                                  </div>
                                </Collapse>
                              </div>

                              <div className="Minutes3">
                                <Box sx={{ padding: '10px 20px', background: '#fff', borderRadius: '12px', marginTop: '20px', backgroundColor: '#2F024E' }}>
                                  <div className="display-2 ">
                                    <Typography id="modal-modal-title" variant="h6" component="h5" sx={{ color: '#fff' }}>
                                    Agents
                                    </Typography>
                                    <CircularProgressWithLabel color="inherit" value={progress} />
                                  </div>
                                </Box>
                                <Collapse in={expandedMap} timeout="auto" unmountOnExit>
                                  <div className="My-Subscription-Details-Minutes">
                                    <div className="display-2 mb-10">
                                      <Typography id="modal-modal-title" variant="h6" component="h6" sx={{ color: '#000', fontSize: '14px' }}>
                                        Total Minutes
                                      </Typography>
                                      <Typography id="modal-modal-title" variant="p" component="p" sx={{ color: '#000' }}>
                                        1/5
                                      </Typography>
                                    </div>
                                    <BorderLinearProgress variant="determinate" value={50} />
                                  </div>
                                  <div className="My-Subscription-Details-Minutes">
                                    <div className="display-2 mb-10">
                                      <Typography id="modal-modal-title" variant="h6" component="h6" sx={{ color: '#000', fontSize: '14px' }}>
                                      Primary Minutes
                                      </Typography>
                                      <Typography id="modal-modal-title" variant="p" component="p" sx={{ color: '#000' }}>
                                        1/5
                                      </Typography>
                                    </div>
                                    <BorderLinearProgress variant="determinate" value={35} />
                                  </div>
                                </Collapse>
                              </div>

                            </div>

                            

                          </Grid2>
                        </Grid2>
                      </Box>

                    </div>
                  </CustomTabPanel>
                  <CustomTabPanel value={tab} index={1}>
                    <div className="View-Invoice-Table">
                      <Box component="main" >
                        <Grid2 container spacing={2} sx={{ alignItems: 'center' }}>
                          <Grid2
                            item
                            size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
                            className="mb-20"
                          >
                            <Grid2 container spacing={2}>
                              <Grid2
                                item
                                size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
                              >
                                <div className="input-common DatePicker-button">
                                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer
                                      components={['DatePicker']}
                                    >

                                      <DemoItem>
                                        <label>Start Date</label>
                                        <DatePicker defaultValue={dayjs('2022-04-17')} />
                                      </DemoItem>
                                    </DemoContainer>
                                  </LocalizationProvider>
                                </div>

                              </Grid2>
                              <Grid2
                                item
                                size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
                              >
                                <div className="input-common DatePicker-button">
                                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer
                                      components={['DatePicker']}
                                    >
                                      <DemoItem>
                                        <label>End Date</label>
                                        <DatePicker defaultValue={dayjs('2022-04-17')} />
                                      </DemoItem>
                                    </DemoContainer>
                                  </LocalizationProvider>
                                </div>
                              </Grid2>
                            </Grid2>
                          </Grid2>
                          <Grid2
                            item
                            size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}

                          >
                            <Stack direction="row" sx={{ mt: 2, justifyContent: 'end' }}>
                              <div className="input-common">
                                <TextField
                                  size="small"
                                  placeholder="Search History"
                                  value={searchValue}
                                  className="search-bar"
                                  onChange={(e) => setSearchValue(e.target.value)}
                                  InputProps={{
                                    endAdornment: (
                                      <IconButton onClick={handleSearch}>
                                        <SearchIcon />
                                      </IconButton>
                                    ),
                                  }}
                                />
                              </div>
                            </Stack>


                          </Grid2>

                          <Grid2
                            item
                            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                            className="mb-20"
                          >
                            <div className="ContactListTable-main">
                              <TableContainer component={Paper} sx={{ maxHeight: 440, borderRadius: '20px 20px 0px 0px' }}>
                                <Table sx={{ minWidth: 700 }} stickyHeader aria-label="sticky table">
                                  <TableHead>
                                    <TableRow>
                                      <StyledTableCell align="center">Invoice ID</StyledTableCell>
                                      <StyledTableCell align="center">Created At</StyledTableCell>
                                      <StyledTableCell align="center">Amount Due</StyledTableCell>
                                      <StyledTableCell align="center">Amount Paid</StyledTableCell>
                                      <StyledTableCell align="center">Billing Reason</StyledTableCell>
                                      <StyledTableCell align="center">Status</StyledTableCell>
                                      <StyledTableCell align="center">Actions</StyledTableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {rows.map((row) => (
                                      <StyledTableRow key={row.name}>
                                        <StyledTableCell component="th" scope="row"><h4> Contact_1</h4></StyledTableCell>
                                        <StyledTableCell align="center"><h4>Shyam</h4></StyledTableCell>
                                        <StyledTableCell align="center"><h4>+91-562356265</h4></StyledTableCell>
                                        <StyledTableCell align="center"><h4 className="green">Yes</h4></StyledTableCell>
                                        <StyledTableCell align="center"><h4>50 min</h4></StyledTableCell>
                                        <StyledTableCell align="center"><h4>50 min</h4></StyledTableCell>
                                        <StyledTableCell align="center">    <Stack direction="row" spacing={2} sx={{ justifyContent: 'center' }}> <Link to='/contact-list-view'> <svg xmlns="http://www.w3.org/2000/svg" width="40" height="22" viewBox="0 0 40 22" fill="none">
                                          <path fill-rule="evenodd" clip-rule="evenodd" d="M1.76172 18.5155C5.6476 15.8802 9.09831 14.3849 12.1138 14.0297C15.1294 13.6744 18.0004 13.6207 20.7268 13.8686L20.7268 18.5879L33.5264 10.8872L20.7268 3.58789L20.7268 8.07333C15.6852 8.09539 11.3991 9.10024 7.86848 11.0879C4.33889 13.0755 2.30331 15.5514 1.76172 18.5155Z" fill="#707070" stroke="#707070" stroke-width="1.76471" stroke-linejoin="round" />
                                        </svg></Link>
                                        </Stack></StyledTableCell>
                                      </StyledTableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                              <TablePagination
                                rowsPerPageOptions={[3, 25, 100]}
                                component="div"
                                count={rows.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                              />
                            </div>
                          </Grid2>
                        </Grid2>
                      </Box>
                    </div>
                  </CustomTabPanel>
                  {/* <CustomTabPanel value={tab} index={2}>
                    Item Three
                  </CustomTabPanel> */}
                </div>
              </div>
            </Grid2>
          </Grid2>
        </Box>
      </Box>
    </div>
  )
}

export default Billing